module.exports = __webpack_public_path__ + "static/media/mount_waddington.8c39e1fb.jpg";